import excelImage from "web/images/xls.png"
import docImage from "web/images/doc.png"
import pdfImage from "web/images/pdf.png"
import unknownImage from "web/images/unknown_type.png"
import { Icon, InlineLoading } from "web/components"

const iconsForType = {
  "application/vnd.openxmlformats-officedocument.wordprocessingml.document":
    docImage,
  "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet":
    excelImage,
  "application/pdf": pdfImage,
}

export default function DocumentIcon({
  width,
  height,
  document: { content_type, uploading, error },
}) {
  if (error) {
    return (
      <div className="text-red-600">
        <Icon name="exclamation-circle" outline />
      </div>
    )
  }

  if (uploading) {
    return <InlineLoading />
  }

  return (
    <img
      width={width}
      height={height}
      alt="document icon"
      src={iconsForType[content_type] || unknownImage}
    />
  )
}
